"use client";

import { Text, Flex, Box, Link } from "@radix-ui/themes";
import React, { useEffect, useState, useRef } from "react";
import { OTP_TIMER } from "../config/constants";

type CounterProps = {
  enableCounter: boolean;
  handleResend: () => void;
};

const ResendCounter: React.FC<CounterProps> = (props) => {
  const [resendCounter, setResendCounter] = useState<number>(OTP_TIMER);
  const intervalID = useRef<any>(null);

  useEffect(() => {
    if (props.enableCounter) {
      setResendCounter(OTP_TIMER);
      if (intervalID.current) clearInterval(intervalID.current);
      intervalID.current = setInterval(() => {
        setResendCounter((counter) => {
          if (counter <= 1) {
            clearInterval(intervalID.current!);
            return 0;
          }
          return counter - 1;
        });
      }, 1000);
    }

    return () => {
      if (intervalID.current) clearInterval(intervalID.current);
    };
  }, [props.enableCounter]);

  return (
    <Box>
      {resendCounter <= 0 && (
        <Flex justify="end" mt="2" gap="2" ml="auto" className="w-full">
          <Text size="1">{`Didn't receive OTP?`}</Text>
          <Link size="1" underline="hover" onClick={props.handleResend} aria-label="Resend OTP code" role="button">
            Resend
          </Link>
        </Flex>
      )}
      {resendCounter > 0 && (
        <Flex justify="end" mt="2" gap="2" mr="4" className="w-full">
          <Text size="1">Resend OTP in</Text>
          <Link size="1" className="hover:cursor-default w-4" aria-label={`Resend OTP in ${resendCounter} seconds`} role="timer">
            {resendCounter >= 10 ? resendCounter : `0${resendCounter}`}
          </Link>
        </Flex>
      )}
    </Box>
  );
};

export default ResendCounter;
